import { ISchoolDTOIn } from '../interfaces/groups/school.interface';

export const mockSchools: ISchoolDTOIn[] = [
    {
        id: 1000,
        education_level_ids: [1],
        name: 'School 1',
        is_active: true,
        education_type_id: 2,
        email: 'school1@liege.be',
        mobile_number: '0471884574',
        home_number: '042873254',
        website: 'www.intotheweb.be',
        vat_number: 'BE08.2464.2233',
        bank_account: 'BE32541215236598',
        address: {
            street: 'rue de la cathédrale',
            home_number: '1',
            box: '',
            additional_information: '',
            postal_code: '4000',
            city: 'Liège',
            country: 'Belgique',
        },
        schedules: [
            { id: 1, day: 'monday', start_time: '08:30', end_time: '16:30' },
            { id: 2, day: 'tuesday', start_time: '08:30', end_time: '16:30' },
            { id: 3, day: 'wednesday', start_time: '08:30', end_time: '12:30' },
            { id: 4, day: 'thursday', start_time: '08:30', end_time: '16:30' },
            { id: 5, day: 'friday', start_time: '08:30', end_time: '16:30' },
        ],
        employee_ids: [1],
        school_setting: {
            calendar: true,
            shop_setting: {
                is_active: true,
                meals: true,
                nursery: true,
                homeworks: true,
                activities: false,
                electronic_payments: true,
            },
            trd_name: 'Steve',
            trd_role: 'Director',
        },
        school_year_id: 1,
    },
];
